
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.772 13.01c.18 0 .36-.06.51-.19l2.97-2.62v11.87c0 .43.35.77.77.77h17.48c.43 0 .77-.35.77-.77V10.19l2.97 2.62c.15.13.33.19.51.19.21 0 .43-.09.58-.26.28-.32.25-.81-.07-1.09l-13-11.47c-.03-.02-.06-.03-.09-.05a.913.913 0 00-.13-.08.737.737 0 00-.14-.04c-.03 0-.08-.01-.13-.01s-.1.01-.15.02a.567.567 0 00-.27.12c-.03.02-.06.03-.09.05l-13 11.47c-.32.28-.35.77-.07 1.09a.8.8 0 00.58.26zm5.03-4.18l7.96-7.03 7.96 7.03V21.3H5.802V8.83z","fill":"#fff"}})])
          )
        }
      }
    